import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.PaymentDetailsStatus', {
    paidPreviously: 'You have paid this contact before. No changes in the payment details.',
    neverPaid: 'You are paying this contact for the first time.',
    paymentDetailsChanged: 'You have paid this contact before. Its payment details have changed.',
});
